export default {
  modal: {
    show: false,
    type: '',
    message: ''
  }
}